import { useCallback, useState } from 'react';

// Token-paired, like dictation, so choosing the same card twice inserts twice.
export const useXoeComposerInsert = () => {
	const [inserted, setInserted] = useState<{ text: string; token: number }>({ text: '', token: 0 });
	const insert = useCallback((text: string) => {
		setInserted((prev) => ({ text, token: prev.token + 1 }));
	}, []);
	return { insertedText: inserted.text, insertToken: inserted.token, insert };
};
